// import { transparentize } from '@theme-ui/color';
import brandColors from './brandColors';
const {
  white,
  electricBlue,
  hoverBlue,
  concordBlue,
  lighterBlue,
  lightestBlue,
  lightGray,
  gray,
  black,
  silver,
  lightSmoke,
  smoke,
  lightGraphite,
  graphite,
} = brandColors;

// Role based colors.
// The description is used by the generated design system documentation.
const colors = {
  brand: { color: brandColors, description: 'The brand specific colors' },
  text: {
    color: black,
    description: 'The main text color.',
  },
  background: {
    color: white,
    description: 'The main background color.',
  },
  primary: {
    color: electricBlue,
    description: 'Main actions, CTAs, links, display colors.',
  },
  onPrimary: {
    color: white,
    description:
      'A readable color when used with the primary color as the background, for example for buttons.',
  },
  secondary: {
    color: hoverBlue,
    description: 'Main hover colors. Only used as a hover.',
  },
  onSecondary: {
    color: white,
    description:
      'A readable color when used with the secondary color as the background, for example for buttons.',
  },
  accent: { color: concordBlue, description: 'Backgrounds. Display text.' },
  onAccent: {
    color: lighterBlue,
    description: 'Background, text over concord blue. Iconography',
  },
  onDark: {
    color: white,
    description: 'A text color to use on dark or colored backgrounds.',
  },
  border: {
    color: lightGray,
    description: 'A color for thin and light borders of UI elements.',
  },
  borderSecondary: {
    color: gray,
    description: 'A secondary border color, e.g. for hovering over list items.',
  },
  borderNuanced: {
    color: lightSmoke,
    description:
      'A very well visible border color, e.g. for hovering over outline buttons.',
  },
  white: {
    color: white,
    description:
      'Pure white. For dark mode, this should be set to a dark tone. (TODO not really sure yet)',
  },
  black: {
    color: black,
    description:
      'Pure black. For dark mode, this should be set to white. (TODO not sure about that yet)',
  },
  light: {
    color: silver,
    description:
      'A very light background color, used for sections with white content blocks on it, for example on the homepage.',
  },
  nuanced: {
    color: lightGray,
    description:
      'A nuanced background color, used for sections that have to stand out more.',
  },
  title: {
    color: graphite,
    description: 'The text color for titles.',
  },
  selected: {
    color: lightestBlue,
    description:
      'A background color for selected items, like rows or list items',
  },
  lightText: {
    color: lightGraphite,
    description:
      'A text color as a variant that is a bit lighter than the main text color. Used as text color on light background.',
  },
  lighterText: {
    color: smoke,
    description: 'A text color for discernably lighter text.',
  },
  lightestText: {
    color: lightSmoke,
    description:
      'A text color for very light text, for example input placeholders.',
  },
  overlay: {
    color: 'rgba(0, 0, 0, 0.4)',
    description:
      'A color for image overlays. Used to make onDark text more readable.',
  },
  overlaySecondary: {
    color: 'rgba(0, 0, 0, 0.6)',
    description: 'A secondary color for image overlays, used for hovering.',
  },

  skeleton: {
    color: lightestBlue,
    description: 'A color used for skeleton components',
  },

  skeletonDark: {
    color: lighterBlue,
    description: 'A color used for the animation of the skeleton components',
  },
};

/**
 * The theme colors as a map.
 * @returns {Object} A map of colors and their values, e.g. { text:'black', background:'transparent' }.
 */
export default Object.entries(colors).reduce(
  // Convert the `{ color,description }` objects to a simple object with key/value pairs.
  (colors, [key, { color }]) => ({ ...colors, [key]: color }),
  {}
);

export const colorsWithDescription = colors;
